import type { SVGProps } from 'react';
const SvgDuck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M34.286 13.929 31.07 12c-.214-.429-1.285-3-3.428-3S24 10.071 24 12c0 2.357.643 4.286.429 6.429-1.5-.215-2.786-.429-4.286-.429C16.5 18 6.214 21 4.5 20.571 5.786 27 11.143 30 19.071 30c3.429.214 7.072-.429 9.643-2.571 2.143-1.929 2.786-6 1.286-8.572-.643-1.071-1.286-2.571-1.5-3.857 0-.429.429-.643 1.071-.429.643.215 2.786.215 4.286.215.214 0 .429 0 .643-.215 0-.214 0-.428-.214-.642" />
  </svg>
);
export default SvgDuck;
